import React from "react";
import "../styles/footerStyles.css";
import { MdEmail } from "react-icons/md";
import { FaLocationDot, FaWhatsapp, FaXTwitter } from "react-icons/fa6";
import { FaLinkedin, FaInstagram, FaFacebookF } from "react-icons/fa";

const Footer = () => {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };


  return (
    <div className="footer" id="footer">
      <div className="footer-container">
        <div className="footer-container-top">
          <div className="footer-info">
            <h5>GET IN TOUCH</h5>
            <div className="footer-info-content">
            
              <div>
                <span>
                  <FaWhatsapp style={{ color: "#fff", marginRight: "10px" }} />
                </span>{" "}
                <a
                  href="https://wa.me/9019446265?text=Hello Himank, I got your number from your website"
                  className="footer-email-link"
                >
                  <span>+91-9019446265</span>
                </a>
              </div>

              
              <div>
                <span>
                  <MdEmail style={{ color: "#fff", marginRight: "10px" }} />
                </span>{" "}
                <a
                  href="mailto:info@maanmasterbatch.com"
                  className="footer-email-link"
                >
                  <span>info@maanmasterbatch.com</span>
                </a>
              </div>


              
              <div>
                {/* <span>
                  <FaLocationDot
                    style={{ color: "#fff", marginRight: "10px" }}
                  />
                </span>{" "}
                <span>Jaipur, Rajasthan, India</span> */}

                <span>
                  <FaLocationDot style={{ color: "#fff", marginRight: "10px" }} />
                </span>{" "}
                <a
                  href="https://maps.app.goo.gl/Pu5npX3yxEZBc6Gk7"
                  className="footer-email-link"
                >
                  <span>Jaipur, Rajasthan, India</span>
                </a>                
              </div>
            </div>
          </div>

          <div className="footer-social">
            <h5>FOLLOW US</h5>
            <div>
              <a
                href="https://www.linkedin.com/company/maanindustries/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin
                  size={20}
                  style={{ color: "#fff", marginRight: "10px" }}
                />
              </a>
              <a
                href="https://www.instagram.com/maanmasterbatch"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram
                  size={20}
                  style={{ color: "#fff", marginRight: "10px" }}
                />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61576250921830"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF
                  size={20}
                  style={{ color: "#fff", marginRight: "10px" }}
                />
              </a>
              <a
                href="https://x.com/MaanMasterbatch"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaXTwitter
                  size={20}
                  style={{ color: "#fff", marginRight: "10px" }}
                />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-container-bottom">
          <p>© 2021 Maan Industries. All rights reserved.</p>
          <p onClick={scrollToTop} style={{cursor:"pointer"}}>SCROLL TOP ↑</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
